module.exports = __webpack_public_path__ + "media/images/shatterproof-a6d8362fe790e50a4ece6f64b4ae8a80.png";